'use client';

import { User } from '@/entities/user';
import { getCartSync } from '@/features/cart/model/store';
import { apiClient } from '@/shared/api';
import { FormActionUserState } from '@/shared/config';
import {
  getApiErrorMessage,
  loginSchema,
  extractFieldErrors,
} from '@/shared/lib';

export async function loginAction(
  prevState: FormActionUserState,
  formData: FormData,
) {
  const email = formData.get('email');
  const password = formData.get('password');

  try {
    await loginSchema.validate({ email, password }, { abortEarly: false });

    const response = await getCartSync().runBoundary('session', () =>
      apiClient<Promise<{ user: User }>>('login', {
        method: 'POST',
        // remember: авторизация (а с ней и корзина аккаунта) живёт долго.
        body: JSON.stringify({ email, password, remember: true }),
      }),
    );

    return {
      ...prevState,
      success: true,
      data: response.user,
    };
  } catch (error) {
    return {
      ...prevState,
      success: false,
      message: getApiErrorMessage(error),
      fieldErrors: extractFieldErrors(error),
    };
  }
}
